import useEventBus from '@/natives/libs/hooks/useEventBus';

const PREFIX = {
  DEFAULT: 'hik_connect_pro_'
};

const refuseCookie = useEventBus('refuse-cookie');
const analyticsCookiesChange = useEventBus('analytics-cookies-change');

analyticsCookiesChange.on(() => {
  initCookieTip();
});

const cookieTipText = document.querySelector('#app-cookie-container span').innerText;
const cookieTipBtnText = document.querySelector('#app-cookie-container a').innerText;
document.querySelector('#app-cookie-container p').innerHTML = cookieTipText.replace(
  `{0}`,
  `<a href="/#/cookiePolicy" target="_blank">${cookieTipBtnText}</a>`
);
document.querySelector('#app-cookie-container p').setAttribute('title', cookieTipText.replace(`{0}`, cookieTipBtnText));
/**
 * 设置cookies参数
 * @param analyCookie
 * @param funCookie
 * @param isChange
 */
function setCookieDes(analyCookie = true, funCookie = true, isChange = false) {
  localStorage.setItem(
    `${PREFIX.DEFAULT }cookie-describe`,
    JSON.stringify({
      analyCookie, // Analytics Cookies
      funCookie, // Functionality Cookies 初始状态 Analytics Cookies 与Functionality Cookies 相等
      isChange // 是否更改cookie管理 默认没更改
    })
  );
}

/**
 * 获取cookies设置参数
 * @returns {{funCookie: (boolean|*), isChange: (boolean|*), analyCookie: (boolean|*)}}
 */
function getCookieDes() {
  return {
    analyCookie: JSON.parse(localStorage.getItem(`${PREFIX.DEFAULT }cookie-describe`))?.analyCookie,
    funCookie: JSON.parse(localStorage.getItem(`${PREFIX.DEFAULT }cookie-describe`))?.funCookie,
    isChange: JSON.parse(localStorage.getItem(`${PREFIX.DEFAULT }cookie-describe`))?.isChange
  };
}

function getLocalUserInfo() {
  let userInfo = '';
  let data = localStorage.getItem(`${PREFIX.DEFAULT }data`) || '';
  if (data) {
    data = new Map(JSON.parse(data));
    if (data.has(`${PREFIX.DEFAULT }user`)) {
      userInfo = data.get(`${PREFIX.DEFAULT }user`).data;
    }
  }
  return userInfo;
}

function getLoginStatus() {
  return !!(
    document.cookie.replace(/(?:^|.*;\s*)hik_connect_pro_userlogin\s*=\s*([^;]*).*$|^.*$/, '$1') && getLocalUserInfo()
  );
}

function initCookieTip() {
  const isLogin = !getLoginStatus();
  let storageHideTip = localStorage.getItem(`${PREFIX.DEFAULT }accepted_cookie_v2`);
  let agreeCookie = storageHideTip || sessionStorage.getItem(`${PREFIX.DEFAULT }useragreeCookie`);
  if (!agreeCookie && !getCookieDes().isChange) {
    setCookieDes(true, true, false);
  }
  let storageHideDescribe = getCookieDes().isChange ? getCookieDes().isChange : false;
  const isPhone = (/(iPhone|iPad|iPod|iOS|Android|Symbian|Windows Phone)/i).test(navigator.userAgent);
  const isDomainName = window.location.href.includes('www.hik-partner.com');
  const isTouristMode = localStorage.getItem(`${PREFIX.DEFAULT }tourist_Mode`) === 'true';
  let isShowCookie = isLogin && !agreeCookie && !storageHideDescribe && !isTouristMode && !isPhone && !isDomainName;
  let cookieContainer = document.getElementById('app-cookie-container');
  cookieContainer.style.display = isShowCookie ? 'block' : 'none';
  if (isShowCookie) {
    document.querySelector('.cookie-btn-content .hpp-button--primary').addEventListener('click', function () {
      localStorage.setItem(`${PREFIX.DEFAULT }accepted_cookie_v2`, '1');
      initCookieTip();
    });
    document.querySelector('.cookie-btn-content .hpp-button--default').addEventListener('click', function () {
      // 管理页
      window.open('/manage-cookies/index.html', '_blank');
    });
    document.querySelector('.cookie-btn-content .hpp-button--link').addEventListener('click', function () {
      setCookieDes(false, false, false);
      localStorage.setItem(`${PREFIX.DEFAULT }accepted_cookie_v2`, '2');
      // analytics cookies的按钮关闭
      refuseCookie.emit();
      initCookieTip();
      // TODO
    });
  }
}

initCookieTip();
